// apps/share-web/src/song-screen/fader-math.ts
//
// Математика строки-фейдера телефонного микшера (вариант B, решение Сергея 16.10).
// Кривая — ТА ЖЕ, что у десктопного bw-volume-bar (@bandway/ui-components/lib/
// gain-curve): −60…+20 dB, 0 dB на 75 % хода. Своей кривой у веба нет — иначе
// «0 dB» на телефоне и на компьютере стояли бы в разных местах хода.
import { POS_UNITY, positionToFactor } from '@bandway/ui-components/lib/gain-curve';

/** Магнит у 0 dB: всё, что ближе 1 dB к нулю, — ровно единица. */
export const MAGNET_DB = 1;

export function dbOf(factor: number): number {
  if (!(factor > 0)) return -Infinity;
  return 20 * Math.log10(factor);
}

/** Позиция хода с магнитом у 0 dB. */
export function snapPosition(pos: number): number {
  const db = dbOf(positionToFactor(pos));
  return Math.abs(db) < MAGNET_DB ? POS_UNITY : pos;
}

/**
 * Относительный ход: новая позиция = позиция в момент захвата + сдвиг пальца,
 * делённый на длину хода. От ТОЧКИ касания не считается — поэтому нажатие без
 * движения ничего не меняет (жалоба Сергея 12.10: «кнопки заедают», и
 * B-260927-fader-quick-regrab-snaps-unity — «тап + захват» давал скачок +24 dB).
 *
 * Вырожденные входы: длина хода ≤ 0 или не число (элемент ещё не разложен) и
 * нечисловой сдвиг — позиция остаётся как была, а не прыгает в конец от 10 px;
 * сдвиг ровно 0 тоже возвращает старт как есть, МИНУЯ магнит (нажатие без
 * движения не должно «примагничивать» 0.74 к нулю). Нечисловая стартовая
 * позиция — 0 dB.
 */
export function dragPosition(startPos: number, dxPx: number, travelPx: number): number {
  if (!Number.isFinite(startPos)) return POS_UNITY;
  if (!(travelPx > 0) || !Number.isFinite(travelPx) || !Number.isFinite(dxPx) || dxPx === 0) return startPos;
  const raw = Math.min(1, Math.max(0, startPos + dxPx / travelPx));
  return snapPosition(raw);
}

/** Подпись уровня без единицы: «0.0», «+3.5», «−12.0», «−∞». */
export function formatLevel(factor: number): string {
  const db = dbOf(factor);
  if (!Number.isFinite(db) || db <= -60) return '−∞';
  const r = Math.round(db * 10) / 10;
  if (r === 0) return '0.0';
  return (r > 0 ? '+' : '−') + Math.abs(r).toFixed(1);
}
